
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBatteryVerticalCharging50 as ObiBatteryVerticalCharging50Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-battery-vertical-charging-50.js';
 
 
 

 
 export const ObiBatteryVerticalCharging50 = createComponent({
   react: React,
   tagName: 'obi-battery-vertical-charging-50',
   elementClass: ObiBatteryVerticalCharging50Element,
   events: {
     
   }
  });
 
 